import { NotificationEntryType } from "../../../Types/notificationEntryType"
import { Form, Formik } from "formik"
import { TextInputField } from "../../FormFields/TextInput/TextInputField"
import { DateInputField } from "../../FormFields/DateInput/DateInputField"
import { Button } from "react-bootstrap"
import { useState } from "react"
import SelectUserModal from "../../Modals/SelectUserModal/selectUserModal"
import useUserRefs from "../../../Hooks/UseUsersQuery/UseUserRefs"
import { useSelector } from "react-redux"
import { accountSelector } from "../../../redux/account/accountSlice"

const generateBlankNotificationEntry = () => ({
  userId: '',
  type: '',
  data: '',
  createdDate: new Date(),
  createdBy: '',
  readDate: null,
  message: '',
  status: 'new'
})

export default function NotificationEntryForm(props: {
  disabled: boolean,
  onSubmit: (v: any) => Promise<any>,
  initialValues?: Partial<NotificationEntryType>,
}) {
  const {
    disabled,
    onSubmit,
    initialValues,
  } = props

  const { _id: currentUserId } = useSelector(accountSelector)
  const userRefs = useUserRefs()
  const [selectUserModal, setSelectUserModal] = useState(false)

  return (
    <div className="notification-entry-form">
      <Formik
        initialValues={{
          ...generateBlankNotificationEntry(),
          ...(initialValues ? initialValues : {}),
          // Set createdBy to current user's ID if not already set
          createdBy: initialValues?.createdBy || currentUserId || '',
        }}
        validate={values => {
          const errors: any = {};
          // Add validation logic here if needed
          return errors;
        }}
        onSubmit={async (values, { setSubmitting }) => {
          if (onSubmit) {
            try {
              onSubmit({ ...values })
            } catch (err) {
              // custom error handler
            }
          }
          setSubmitting(false)
        }}
      >
        {({ values, isSubmitting, errors, touched, setFieldValue, handleChange, setValues }) => {
          return (
            <>
              <Form>
                <h3>👤 User Selection</h3>
                <TextInputField
                  fieldType="text"
                  fieldLabel="User ID"
                  placeholder="User ID"
                  fieldName="userId"
                  disabled={true}
                />
                {values.userId && userRefs[values.userId] && (
                  <div className="mb-3">
                    <small className="text-muted">
                      Selected User: <strong>{userRefs[values.userId].firstName} {userRefs[values.userId].lastName}</strong> ({userRefs[values.userId].email})
                    </small>
                  </div>
                )}
                <div className="mb-3">
                  <Button
                    variant="secondary"
                    size="sm"
                    onClick={() => setSelectUserModal(true)}
                    disabled={disabled}
                  >
                    Select User
                  </Button>
                  {values.userId && (
                    <Button
                      variant="outline-secondary"
                      size="sm"
                      className="ms-2"
                      onClick={() => {
                        setFieldValue('userId', '')
                      }}
                      disabled={disabled}
                    >
                      Clear
                    </Button>
                  )}
                </div>

                <TextInputField
                  fieldType="text"
                  fieldLabel="Type"
                  placeholder="Type"
                  fieldName="type"
                />

                <TextInputField
                  fieldType="textarea"
                  fieldLabel="Message"
                  placeholder="Message"
                  fieldName="message"
                />

                <TextInputField
                  fieldType="textarea"
                  fieldLabel="Data"
                  placeholder="Data (JSON or additional information)"
                  fieldName="data"
                />

                <DateInputField
                  fieldLabel="Created Date"
                  placeholder="Created Date"
                  fieldName="createdDate"
                />

                <TextInputField
                  fieldType="text"
                  fieldLabel="Created By"
                  placeholder="Created By"
                  fieldName="createdBy"
                  disabled={true}
                />
                {values.createdBy && userRefs[values.createdBy] && (
                  <div className="mb-3">
                    <small className="text-muted">
                      Created By: <strong>{userRefs[values.createdBy].firstName} {userRefs[values.createdBy].lastName}</strong> ({userRefs[values.createdBy].email})
                    </small>
                  </div>
                )}

                <TextInputField
                  fieldType="text"
                  fieldLabel="Status"
                  placeholder="Status"
                  fieldName="status"
                />

                {values.status && (
                  <div className="mb-3">
                    <small className="text-muted">
                      Status: <strong>{values.status}</strong>
                    </small>
                  </div>
                )}

                <DateInputField
                  fieldLabel="Read Date"
                  placeholder="Read Date (optional)"
                  fieldName="readDate"
                />

                <hr />
                <div className="mb-3">
                  Errors: {JSON.stringify(errors)}
                </div>

                <Button className="mb-3" type="submit" disabled={Object.keys(errors).length > 0 || isSubmitting || disabled}>
                  Submit
                </Button>

              </Form>

              <SelectUserModal
                active={selectUserModal}
                onClose={() => {
                  setSelectUserModal(false)
                }}
                title="Select User for Notification"
                message="Please select a user to send the notification to:"
                onSelect={(selectedUser: any) => {
                  console.log('Selected user:', selectedUser)
                  // Now we can directly use setFieldValue since we're inside the Formik render prop
                  if (selectedUser._id) {
                    setFieldValue('userId', selectedUser._id)
                  }
                  setSelectUserModal(false)
                }}
              />
            </>
          )
        }}
      </Formik>
    </div>
  )
}
